<template>
    <div class="billing-main-scroll">
        <div class="billing-wallet-hero">
            <div class="billing-wallet-label">{{ $t('common.billing.walletBalance') }}</div>
            <div class="billing-wallet-amount">&#8378;{{ bs.formatPrice(bs.state.walletBalance) }}</div>
            <button class="billing-wallet-topup-btn" @click="bs.toggleTopup()">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                {{ $t('common.billing.topUp') }}
            </button>
        </div>

        <div v-if="bs.state.topupOpen" class="billing-topup-card">
            <div class="billing-form-title">{{ $t('common.billing.topUpAmount') }}</div>
            <div class="billing-topup-amounts">
                <button v-for="amount in [100, 250, 500, 1000]" :key="amount"
                        :class="['billing-topup-amount-btn', {'billing-topup-amount-btn--active': bs.state.topupAmount === amount}]"
                        @click="bs.setTopupAmount(amount)">
                    {{ bs.formatPrice(amount) }}&#8378;
                </button>
                <div class="billing-topup-custom">
                    <input class="billing-topup-input" type="number" :placeholder="$t('common.billing.customAmount')"
                           :value="customTopup"
                           @input="onCustomInput($event.target.value)">
                    <span class="billing-topup-currency">&#8378;</span>
                </div>
            </div>
            <div class="billing-topup-actions">
                <button class="billing-btn billing-btn--ghost" @click="bs.toggleTopup()">{{ $t('common.billing.cancelAction') }}</button>
                <button class="billing-btn billing-btn--primary" :disabled="!bs.state.topupAmount">{{ $t('common.billing.loadBalance') }}</button>
            </div>
        </div>

        <div class="billing-section-title" style="font-size: 13px;">{{ $t('common.billing.walletHistory') }}</div>
        <div class="billing-wallet-history">
            <div v-for="item in bs.WALLET_HISTORY" :key="item.id" class="billing-wallet-row">
                <div :class="['billing-wallet-type-icon', 'billing-wallet-type-icon--' + item.type]">
                    <svg v-if="item.type === 'topup'" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 15 12 9 18 15"/></svg>
                    <svg v-else-if="item.type === 'payment'" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>
                    <svg v-else width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>
                </div>
                <span class="billing-wallet-desc">{{ item.description }}</span>
                <span class="billing-wallet-date">{{ bs.formatDate(item.date) }}</span>
                <span :class="['billing-wallet-amount-cell', item.amount >= 0 ? 'billing-wallet-amount-cell--positive' : 'billing-wallet-amount-cell--negative']">
                    {{ item.amount >= 0 ? '+' : '' }}{{ bs.formatPrice(item.amount) }}&#8378;
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import billingService from './billingService'

export default {
    name: 'BillingWallet',
    computed: {
        bs() {
            return billingService
        },
        customTopup() {
            const presets = [100, 250, 500, 1000]
            if (billingService.state.topupAmount && !presets.includes(billingService.state.topupAmount)) {
                return billingService.state.topupAmount
            }
            return ''
        },
    },
    methods: {
        onCustomInput(val) {
            const n = parseInt(val, 10)
            billingService.setTopupAmount(n > 0 ? n : null)
        },
    },
}
</script>
